import React from 'react';
import {
  AfterSubmitFunc,
  FormTemplate, TextArea,
  TextInput
} from 'ui-builder';
import {
  CreateSetupAreaVersionRequest,
  SetupArea,
  useSetupAreaVersionAdminService
} from 'nekst-api';
import { VersionDropdown } from './VersionDropdown';

export function CreateVersionForm(
  props: {
    setupArea: SetupArea,
    initialSourceVersion?: string,
    afterSubmitFunc?: AfterSubmitFunc,
  }
) {
  const setupAreaVersionAdminService = useSetupAreaVersionAdminService();

  return (
    <FormTemplate<CreateSetupAreaVersionRequest & { sourceVersion?: string }, SetupArea>
      title="Create New Version"
      submitFormFunc={async (data) => {
        if (data.sourceVersion) {
          return await setupAreaVersionAdminService.copyVersion(props.setupArea.id, data.sourceVersion, data);
        } else {
          return await setupAreaVersionAdminService.createVersion(props.setupArea.id, data);
        }
      }}
      validationSchema={{
        version: {
          type: 'string',
          constraints: {
            required: true,
            minLength: 3,
            maxLength: 30,
            regex: {
              value: /^[a-zA-Z0-9\\-]+$/,
              message: 'Alias must start with a letter and can only contain letters, numbers and dashes.'
            }
          }
        }
      }}
      initialData={{
        sourceVersion: props.initialSourceVersion,
      }}
      afterSubmitFunc={props.afterSubmitFunc}
    >
      <TextInput source="version" label="Version" />
      <TextArea source="description" label="Description" />
      <VersionDropdown setupArea={props.setupArea} />
    </FormTemplate>
  );
}
